import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { HistoryList } from '../components/agents/marketingChain';

const MarketingChainHistoryPage = () => {
    const navigate = useNavigate();
    const { user } = useAuthStore();
    const userId = user.userId;

    const handleSelectProposal = (sessionId) => {
        // Navegar a la página de marketing chain con la sesión seleccionada
        navigate(`/marketing-chain?session=${sessionId}`);
    };

    const handleContinueProposal = (proposal) => {
        // Navegar a la página de marketing chain con la sesión para continuar
        navigate(`/marketing-chain?session=${proposal.sessionId}`);
    };

    const handleBackToDashboard = () => {
        navigate('/dashboard');
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="container mx-auto px-4 py-6">
                {/* Header */}
                <div className="mb-8">
                    <div className="flex items-center justify-between">
                        <div>
                            <button
                                onClick={handleBackToDashboard}
                                className="text-gray-600 hover:text-gray-900 mb-4 flex items-center"
                            >
                                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                                Volver al Dashboard
                            </button>
                            <h1 className="text-3xl font-bold text-gray-900 mb-2">
                                Historial de Propuestas de Marketing
                            </h1>
                            <p className="text-gray-600">
                                Revisa y continúa todas tus propuestas de marketing generadas
                            </p>
                        </div>
                        <button
                            onClick={() => navigate('/marketing-chain')}
                            className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
                        >
                            Crear Nueva Propuesta
                        </button>
                    </div>
                </div>

                {/* History List */}
                <HistoryList
                    userId={userId}
                    onSelectProposal={handleSelectProposal}
                    onContinueProposal={handleContinueProposal}
                />
            </div>
        </div>
    );
};

export default MarketingChainHistoryPage; 